import { render, staticRenderFns } from "./HomepageSliderView.vue?vue&type=template&id=6c3388a1&scoped=true&"
import script from "./HomepageSliderView.vue?vue&type=script&lang=js&"
export * from "./HomepageSliderView.vue?vue&type=script&lang=js&"
import style0 from "./HomepageSliderView.vue?vue&type=style&index=0&id=6c3388a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3388a1",
  null
  
)

export default component.exports